import clsx from 'clsx';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import DesktopBanner from 'images/referral/desktop_banner.png';
import giftIcon from 'images/referral/giftbox_icon.svg';
import MobileBanner from 'images/referral/mobile_banner.png';

import LinkCopy from '../../BaseUI/LinkCopy';
import styles from './HeaderStyles.module.scss';

const HeaderSection = ({ referralUrl }: { referralUrl: string }) => {
  const { width } = useWindowSize();

  return (
    <div className={styles.referralHeaderContainer}>
      <div className={clsx(styles.actionContainer)}>
        <img src={width > 768 ? DesktopBanner : MobileBanner} width="100%" />
        <div className={clsx(styles.sectionContainer, 'container')}>
          <div className={clsx(styles.sectionWrapper, 'row')}>
            <div className={clsx(styles.sectionHeader, 'col-sm-12')}>
              The Information is better when friends & colleagues <strong>read together</strong>
            </div>
            <div className={clsx(styles.inviteLinkContainer, 'col-sm-12')}>
              <div className={styles.redBanner}></div>
              <div className={styles.inviteLinkWrapper}>
                <div className={clsx(styles.inviteLinkContent, 'container')}>
                  <img src={giftIcon} width={25} height={25} />
                  <div className={styles.inviteLinkHeader}>
                    As a benefit of your subscription, you can give 14 days of free access to The
                    Information.
                  </div>
                  <div className={styles.inviteLinkSubHeader}>
                    Share this custom offer link with friends and colleagues.
                  </div>
                  <div className={styles.inviteLinkSubHeader}>
                    They save 25%, and you get $50 for every person that signs up*
                  </div>
                  <div className={styles.referralLinkHeader}>Your custom Invite Link</div>
                  <div className={styles.linkWrapper}>
                    <LinkCopy
                      clipboardLink={referralUrl}
                      customClass={styles.linkContainerOverride}
                      trackingProps={{
                        'ahoy-name': 'Referral Landing Page - Click On Copy Referral Link',
                        location: 'referral_landing_page',
                        name: 'copy_referral_link',
                      }}
                    />
                  </div>
                  <div className={styles.disclosure}>
                    *For new annual subscription only. Payouts will be made a month after sign-up
                    and are paid through Venmo or PayPal
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
